<template>
  <aside id="text-3" class="widget widget_text">
    <!-- <div class="h3 widgettitle" v-html="$t('information')"></div> -->
    <div
      class="h3 widgettitle mobile-title"
      :class="{ tablet: $mq.phone }"
      @click.prevent="$mq.phone ? onToggle() : ''"
    >
      {{ $t('information')
      }}<span
        v-if="$mq.phone"
        :class="`seasidetms_theme_icon_slide_${isOpen ? 'bottom' : 'top'}`"
      ></span>
    </div>
    <slide-up-down
      :active="$mq.phone ? !isOpen : isOpen"
      :duration="500"
      ref="footer_menu"
      :class="{ show: $mq.phone }"
    >
      <div class="textwidget">
        <ul>
          <li v-for="item in $mainMenu" :key="item.slug">
            <router-link
              :to="lang ? '/' + lang + '/' + item.uri : '/' + item.uri"
            >
              {{ $t(`mainMenu.${item.slug}`) }}
            </router-link>
          </li>
        </ul>
      </div>
    </slide-up-down>
  </aside>
</template>

<script>
export default {
  name: 'FooterMainMenu',
  data() {
    return {
      isOpen: true,
      lang: '',
    }
  },
  methods: {
    onToggle() {
      this.isOpen = !this.isOpen
    },
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
/* .widgettitle.mobile-title{
    display: block;
  } */
</style>
